// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"489e401b","455":"cc640ee2","977":"f02d0923"}[chunkId] + ".chunk.js";
};